import classes from "./DownloadButton.module.css";
import QRCodeHelper from "../../../../../../helpers/qr-code/QRCodeHelper";
import {useContext} from "react";
import QRCodeViewItemContext from "../QRCodeViewItemContext";
import DownloadPayload from "../../../../../../helpers/qr-code/DownloadPayload";

/**
 * Download button for QRCodeViewItem.
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function DownloadButton({ ...props }) {
    const ctx = useContext(QRCodeViewItemContext);

    const onClick = () => {
        if (!ctx.qrCode || !ctx.qrCode.image) {
            return;
        }

        const dp: DownloadPayload = { fileName: ctx.qrCode.name, imageUrl: ctx.qrCode.image };

        QRCodeHelper.download(dp)
            .then();
    }

    return (
        <button
            onClick={onClick}
            children="Pobierz"
            className={classes.downloadButton}
            {...props}
        />
    );
}

export default DownloadButton;